<template>
  <div class="log-container">
    <div style="margin-bottom: 12px">
      <el-button
        class="mwow-button-filled primary"
        @click="handleExport"
        v-debounce="1000"
      >
        导出
      </el-button>
      <el-button
        class="mwow-button-filled"
        @click="handleOperateLog"
        v-debounce="1000"
      >
        操作记录
      </el-button>
    </div>
    <common-search-form-wrapper :reset="handleSearchReset">
      <el-form size="mini" :model="searchInfo" label-width="64px">
        <el-row>
          <el-col :span="7">
            <el-form-item label="订单号:" prop="order_no">
              <el-input
                v-model="searchInfo.order_no"
                placeholder="请输入订单号"
                @change="handleSearch"
                clearable
                @clear="handleSearch"
                prefix-icon="el-icon-search"
                maxlength="120"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="学员:" prop="student_key_word">
              <el-select
                v-model.number="searchInfo.student_id"
                filterable
                clearable
                placeholder="请选择"
                :filter-method="handleSearchStudent"
                @change="handleSearch"
                @focus="handleSearchStudent('')"
              >
                <el-option
                  v-for="item in searchStudentList"
                  :key="item.student_id"
                  :label="item.name"
                  :value="item.student_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="支付渠道:" prop="payment_method">
              <el-select
                v-model="searchInfo.payment_method"
                placeholder="请选择"
                @change="handleSearch"
              >
                <el-option
                  v-for="item in payChannelList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="创建时间:" prop="create_date">
              <common-date-range-selector
                v-model="searchInfo.create_date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="handleSearch"
                value-format="yyyy-MM-dd"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="支付时间:" prop="payment_date">
              <common-date-range-selector
                v-model="searchInfo.payment_date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="handleSearch"
                value-format="yyyy-MM-dd"
                :clearable="false"
                :pickerOptions="paymentDatePickerOption"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="废除状态:" prop="abolish_status">
              <el-radio-group
                v-model="searchInfo.abolish_status"
                @change="handleSearch"
              >
                <el-radio-button :label="-1">全部</el-radio-button>
                <el-radio-button :label="2">未废除</el-radio-button>
                <el-radio-button :label="1">已废除</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16">
            <el-form-item label="订单状态:" prop="order_status">
              <el-radio-group
                v-model="searchInfo.order_status"
                @change="handleSearch"
              >
                <el-radio-button :label="-1">全部</el-radio-button>
                <el-radio-button :label="1">待付款</el-radio-button>
                <el-radio-button :label="5">部分付款</el-radio-button>
                <el-radio-button :label="2">已付款</el-radio-button>
                <el-radio-button :label="4">已取消</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </common-search-form-wrapper>
    <el-table
      size="mini"
      v-horizontal-scroll
      :data="tableData"
      stripe
      ref="mainTable"
      style="width: 100%"
      tooltip-effect="dark"
      @sort-change="clickSort"
    >
      <el-table-column label="订单号" prop="order_no" width="160" fixed="left">
        <template slot-scope="scope">
          <span
            class="mwow-green"
            style="cursor: pointer"
            @click="toOrderDetail(scope.row)"
            >{{ scope.row.order_no }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        label="支付单号"
        prop="order_pay_no"
        width="170"
        fixed="left"
      >
        <template slot-scope="scope"
          >{{ scope.row.order_pay_no || "-" }}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="create_time" width="130">
        <template slot-scope="scope">
          {{ scope.row.create_time }}
        </template>
      </el-table-column>
      <el-table-column
        label="支付时间"
        prop="payment_time"
        width="130"
        sortable="custom"
        :sort-orders="['ascending', 'descending']"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.payment_time }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="支付渠道"
        prop="payment_name"
        width="120"
      ></el-table-column>
      <el-table-column
        label="支付金额"
        prop="payment_amount"
        min-width="90"
      ></el-table-column>
      <el-table-column
        label="手续费金额"
        prop="wow_pay_fee_amount"
        min-width="110"
        v-if="onlinePay"
      >
        <template slot="header">
          手续费金额
          <el-tooltip effect="dark" placement="top">
            <div slot="content">
              乐沃收银的支付单收取手续费金额，其它支付方式不收取
            </div>
            <span
              ><i
                class="el-icon-question"
                style="
                  margin-left: 8px;
                  color: #bebfc0;
                  font-size: 16px;
                  vertical-align: text-bottom;
                "
              ></i
            ></span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        label="服务费金额"
        prop="wow_pay_wow_fee_amount"
        min-width="110"
        v-if="onlinePay"
      >
        <template slot="header">
          服务费金额
          <el-tooltip effect="dark" placement="top">
            <div slot="content">
              乐沃收银的课程支付单收取服务费金额，活动支付单及其它支付方式不收取
            </div>
            <span
              ><i
                class="el-icon-question"
                style="
                  margin-left: 8px;
                  color: #bebfc0;
                  font-size: 16px;
                  vertical-align: text-bottom;
                "
              ></i
            ></span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        label="入账金额"
        prop="wow_pay_settle_amount"
        min-width="110"
        v-if="onlinePay"
      >
        <template slot="header">
          入账金额
          <el-tooltip effect="dark" placement="top">
            <div slot="content">乐沃收银的支付单入账金额</div>
            <span
              ><i
                class="el-icon-question"
                style="
                  margin-left: 8px;
                  color: #bebfc0;
                  font-size: 16px;
                  vertical-align: text-bottom;
                "
              ></i
            ></span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        label="入账状态"
        prop="wow_pay_settle_status"
        width="100"
        v-if="onlinePay"
      >
        <template slot="header">
          入账状态
          <el-tooltip effect="dark" placement="top">
            <div slot="content">乐沃收银的支付单金额入账状态</div>
            <span
              ><i
                class="el-icon-question"
                style="
                  margin-left: 8px;
                  color: #bebfc0;
                  font-size: 16px;
                  vertical-align: text-bottom;
                "
              ></i
            ></span>
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          {{ scope.row.wow_pay_settle_status }}
        </template>
      </el-table-column>
      <el-table-column label="订单状态" prop="order_status" width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.order_status === 1">待付款</span>
          <span v-else-if="scope.row.order_status === 2">已付款</span>
          <span v-else-if="scope.row.order_status === 3">-</span>
          <span v-else-if="scope.row.order_status === 4">已取消</span>
          <span v-else-if="scope.row.order_status === 5">部分付款</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="审批状态" prop="approval_status" width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.approval_status === 0">无审批</span>
          <span v-else-if="scope.row.approval_status === 1">审批中</span>
          <span v-else-if="scope.row.approval_status === 2">已同意</span>
          <span v-else-if="scope.row.approval_status === 3">已拒绝</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="废除状态" prop="order_status" width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.order_status === 3">已废除</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        label="学员"
        prop="student.name"
        min-width="100"
      ></el-table-column>
      <el-table-column
        label="创建人"
        prop="create_staff.name"
        min-width="100"
      ></el-table-column>
      <el-table-column label="业务人员" min-width="120">
        <template slot-scope="scope">{{
          scope.row.belong_staffs
            .map((s) => {
              return s.name;
            })
            .join("、")
        }}</template>
      </el-table-column>
      <el-table-column label="操作" width="160" fixed="right">
        <template slot-scope="scope">
          <!-- 该按钮针对未开通乐沃收银(没有扫码类型支付的订单)，且订单状态不为已取消、已废除，且有编辑权限且距离创建时间在门店订单编辑有效期内 -->
          <el-button
            class="mwow-button"
            @click="handleEditTime(scope.row)"
            v-debounce="1000"
            v-if="handleChangePayTime(scope.row)"
          >
            更改支付时间
          </el-button>
          <div v-else>-</div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 统计 -->
    <div class="statistics-wrap">
      <div class="statistics-total">
        <div
          class="mwow-button-filled mini"
          @click="statisticsCollapse = !statisticsCollapse"
          :class="{ success: statisticsCollapse }"
        >
          {{ statisticsCollapse ? "展开" : "收起" }}
        </div>
        <span
          >时间：{{
            searchInfo.payment_date[0] + " - " + searchInfo.payment_date[1]
          }}</span
        >
        <span>支付单数：{{ statisticsTotalData.payment_num }}</span>
        <span>支付金额：￥{{ statisticsTotalData.payment_amount }}</span>
        <span>废除单数：{{ statisticsTotalData.abolish_num }}</span>
        <span>废除金额：￥{{ statisticsTotalData.abolish_amount }}</span>
      </div>
      <el-table
        size="mini"
        :data="statisticsTableData"
        stripe
        tooltip-effect="dark"
        v-show="!statisticsCollapse"
      >
        <el-table-column
          label="支付渠道"
          prop="payment_method_name"
        ></el-table-column>
        <el-table-column label="支付单数" prop="payment_num"></el-table-column>
        <el-table-column
          label="支付金额"
          prop="payment_amount"
        ></el-table-column>
        <el-table-column
          label="已入账金额"
          prop="settle_amount"
          v-if="onlinePay"
        ></el-table-column>
        <el-table-column
          label="未入账金额"
          prop="not_settle_trade_amount"
          v-if="onlinePay"
        ></el-table-column>
        <el-table-column
          label="服务费金额"
          prop="wow_fee_amount"
          v-if="onlinePay"
        ></el-table-column>
        <el-table-column
          label="手续费金额"
          prop="fee_amount"
          v-if="onlinePay"
        ></el-table-column>
      </el-table>
    </div>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      :style="{ float: 'right', padding: '20px' }"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
    <edit-time-dialog
      :visible="editTime.editTimeVisible"
      :originData="editTime"
      @change="handleEditTimeChange"
    >
    </edit-time-dialog>
    <operate-log-dialog
      :visible="operateLogVisible"
      @change="handleOperateLogChange"
    ></operate-log-dialog>
  </div>
</template>
<script>
import {
  getOrderPaymentLogApi,
  exportOrderPaymentLogApi,
  getOrderPaymentStatisticsApi,
} from "@/api/order";
import { exportLoop } from "@/utils/export";
import { dateFormat } from "@/utils/timeFormat";
import { searchStudent } from "@/api/globalSearch";
import { UserModule } from "@/store/module/user";
import CommonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";
import editTimeDialog from "./editTimeDialog.vue";
import operateLogDialog from "./operateLogDialog.vue";
import { staffCheckApi } from "@/api/makeUpLessons";
import { PageModule } from "@/store/module/page";

export default {
  props: ["visible"],
  components: {
    CommonSearchFormWrapper,
    commonDateRangeSelector,
    editTimeDialog,
    operateLogDialog,
  },
  data() {
    return {
      searchInfo: {
        sort_type: "desc",
        sort_field: "create_time",
        payment_date: [],
        create_date: [],
        order_no: "",
        student_id: "",
        payment_method: -1,
        order_status: -1,
        abolish_status: -1,
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      searchStudentList: [],
      statisticsTableData: [],
      statisticsTotalData: {
        payment_num: 0,
        payment_amount: 0,
        abolish_num: 0,
        abolish_amount: 0,
      },
      statisticsCollapse: true,
      editTime: {
        editTimeVisible: false,
        order_no: "",
        payment_time: "",
        order_payment_id: "",
      },
      operateLogVisible: false,
      isEditAuth: false, // 是否有编辑权限
      paymentDatePickerOption: {
        disabledDate: (day, first) => {
          if (first) {
            return !(
              day.getTime() < first.getTime() + 365 * 24 * 60 * 60 * 1000 &&
              day.getTime() > first.getTime() - 365 * 24 * 60 * 60 * 1000
            );
          } else {
            return false;
          }
        },
      },
    };
  },
  computed: {
    onlinePay() {
      return UserModule.userInfo.online_pay;
    },
    // 获取门店的订单编辑最大有效期
    isEditMaxDays() {
      return UserModule.userInfo.order_edit_payment_time_max_days;
    },
    payChannelList() {
      let arr = [
        {
          value: -1,
          label: "全部",
        },
        {
          value: 1,
          label: "支付宝",
        },
        {
          value: 2,
          label: "微信",
        },
        {
          value: 3,
          label: "现金",
        },
        {
          value: 5,
          label: "pos机刷卡",
        },
        {
          value: 6,
          label: "转账",
        },
      ];
      if (this.onlinePay) {
        arr.push({
          value: 11,
          label: "乐沃收银",
        });
      }
      return arr;
    },
  },
  created() {
    // 只有从订单详情中返回时，searchInfo 使用缓存的数据
    if (this.$route.query.from === "order_detail") {
      let pageCache = sessionStorage.getItem(
        "finance-center-order-management-order-log-cache"
      );
      if (pageCache) {
        let pageCacheJSON = JSON.parse(pageCache);
        if (pageCacheJSON.page) {
          this.page = Number(pageCacheJSON.page);
        }
        if (pageCacheJSON.page_size) {
          this.pageSize = Number(pageCacheJSON.page_size);
        }
        if (pageCacheJSON.search_info) {
          this.searchInfo = pageCacheJSON.search_info;
        }
      } else {
        this.searchInfo.payment_date = [
          dateFormat(
            "YYYY-mm-dd",
            new Date().getTime() - 365 * 24 * 60 * 60 * 1000
          ),
          dateFormat("YYYY-mm-dd", new Date().getTime()),
        ]; // 默认最近一年数据
      }
      setTimeout(() => {
        sessionStorage.removeItem(
          "finance-center-order-management-order-log-cache"
        );
      }, 1000);
    } else {
      this.searchInfo.payment_date = [
        dateFormat(
          "YYYY-mm-dd",
          new Date().getTime() - 365 * 24 * 60 * 60 * 1000
        ),
        dateFormat("YYYY-mm-dd", new Date().getTime()),
      ]; // 默认最近一年数据
    }
    // 单次watch页面展示，然后加载数据
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        this.init();
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      this.init();
    }
  },
  methods: {
    init() {
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
      staffCheckApi({ api_path: ["/api/v1/order/payment/edit/time"] })
        .then((res) => {
          if (res.error_code === 0) {
            this.isEditAuth = res.data["/api/v1/order/payment/edit/time"];
          }
        })
        .catch(() => {
          this.isEditAuth = false;
        });
    },
    handleSearchStudent(v) {
      searchStudent({
        page: 1,
        page_size: 50,
        key_word: v || "",
      }).then((res) => {
        if (res.error_code === 0) {
          this.searchStudentList = res.data.list;
        }
      });
    },
    solveSearchParams() {
      let option = {};
      if (this.searchInfo.payment_date) {
        option.payment_date_1 = this.searchInfo.payment_date[0];
        option.payment_date_2 = this.searchInfo.payment_date[1];
      }
      if (this.searchInfo.create_date) {
        option.create_date_1 = this.searchInfo.create_date[0];
        option.create_date_2 = this.searchInfo.create_date[1];
      }
      if (this.searchInfo.order_no) {
        option.order_no = this.searchInfo.order_no;
      }
      if (this.searchInfo.student_id) {
        option.student_id = this.searchInfo.student_id;
      }
      if (this.searchInfo.payment_method > 0) {
        option.payment_method = this.searchInfo.payment_method;
      }
      if (this.searchInfo.order_status > 0) {
        option.order_status = this.searchInfo.order_status;
      }
      if (this.searchInfo.abolish_status > 0) {
        option.abolish_status = this.searchInfo.abolish_status;
      }
      return option;
    },
    handleSearchReset() {
      this.searchInfo = {
        payment_date: this.searchInfo.payment_date,
        create_date: [],
        order_no: "",
        student_id: "",
        payment_method: -1,
        order_status: -1,
        abolish_status: -1,
        sort_type: this.searchInfo.sort_type,
        sort_field: this.searchInfo.sort_field,
      };
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    getTatistics() {
      let option = this.solveSearchParams();
      getOrderPaymentStatisticsApi(option).then((res) => {
        if (res.error_code === 0) {
          res.data.list.map((item) => {
            if (item.payment_method_name.indexOf("乐沃收银") < 0) {
              item.settle_amount = "-";
              item.not_settle_trade_amount = "-";
              item.wow_fee_amount = "-";
              item.fee_amount = "-";
            } else {
              item.settle_amount = item.settle_amount
                ? "￥" + item.settle_amount
                : "-";
              item.not_settle_trade_amount = item.not_settle_trade_amount
                ? "￥" + item.not_settle_trade_amount
                : "-";
              item.wow_fee_amount = item.wow_fee_amount
                ? "￥" + item.wow_fee_amount
                : "-";
              item.fee_amount = item.fee_amount ? "￥" + item.fee_amount : "-";
            }
            item.payment_amount = item.payment_amount
              ? "￥" + item.payment_amount
              : "-";
          });
          if (this.onlinePay) {
            this.statisticsTableData = res.data.list;
          } else {
            this.statisticsTableData = res.data.list.filter((it) => {
              return it.payment_method_name.indexOf("乐沃收银") < 0;
            });
          }
          this.statisticsTotalData = res.data.total;
        }
      });
    },
    getList(params) {
      const option = {
        page: params.page,
        page_size: params.page_size,
        ...this.solveSearchParams(),
      };
      if (this.searchInfo.sort_type && this.searchInfo.sort_field) {
        option.sort_type = this.searchInfo.sort_type;
        option.sort_field = this.searchInfo.sort_field;
      }
      getOrderPaymentLogApi(option).then((res) => {
        if (res.error_code === 0) {
          res.data.list.map((item) => {
            item.create_time = dateFormat(
              "YYYY-mm-dd HH:MM",
              new Date(item.create_time * 1000)
            );
            item.payment_time = item.payment_time
              ? dateFormat(
                  "YYYY-mm-dd HH:MM",
                  new Date(item.payment_time * 1000)
                )
              : "-";
            item.payment_amount = item.payment_amount
              ? "￥" + item.payment_amount
              : "-";
            if (item.wow_pay && item.payment_name.indexOf("乐沃收银") >= 0) {
              item.wow_pay_fee_amount = item.wow_pay.fee_amount
                ? "￥" + item.wow_pay.fee_amount
                : "-";
              item.wow_pay_settle_amount = item.wow_pay.settle_amount
                ? "￥" + item.wow_pay.settle_amount
                : "-";
              item.wow_pay_wow_fee_amount = item.wow_pay.wow_fee_amount
                ? "￥" + item.wow_pay.wow_fee_amount
                : "-";
              item.wow_pay_settle_status =
                item.wow_pay.settle_status === 0
                  ? "-"
                  : item.wow_pay.settle_status === 1
                  ? "已入账"
                  : "未入账";
            } else {
              item.wow_pay_fee_amount = "-";
              item.wow_pay_settle_amount = "-";
              item.wow_pay_wow_fee_amount = "-";
              item.wow_pay_settle_status = "-";
            }
          });
          this.tableData = res.data.list;
          this.total = res.data.total;
          this.page = params.page;
        }
      });
      this.getTatistics();
    },
    handleIsEditMaxDays(row) {
      let now = Date.now();
      let curCreateTime = new Date(row.create_time).getTime();
      let validDate = false; // 是否在有效时间
      if (now - curCreateTime < this.isEditMaxDays * 24 * 60 * 60 * 1000) {
        validDate = true;
      } else {
        validDate = false;
      }
      return validDate;
    },
    // 该按钮针对未开通乐沃收银(没有扫码类型支付的订单)，且订单状态不为已取消、已废除，且有编辑权限且距离创建时间在门店订单编辑有效期内
    handleChangePayTime(row) {
      let auth = false;
      if (
        row.payment_method !== 7 &&
        row.payment_method !== 11 &&
        row.order_status !== 4 &&
        row.order_status !== 3 &&
        this.isEditAuth &&
        this.handleIsEditMaxDays(row)
      ) {
        auth = true;
      }
      return auth;
    },
    handleEditTime(row) {
      this.editTime.editTimeVisible = true;
      this.editTime.payment_time = row.payment_time;
      this.editTime.order_no = row.order_no;
      this.editTime.order_payment_id = row.order_payment_id;
    },
    handleEditTimeChange(rest) {
      this.editTime.editTimeVisible = false;
      if (rest) {
        this.getList({
          page: 1,
          page_size: 10,
        });
      }
    },
    handleOperateLog() {
      this.operateLogVisible = true;
    },
    handleOperateLogChange() {
      this.operateLogVisible = false;
    },
    handleExport() {
      const option = this.solveSearchParams();
      exportOrderPaymentLogApi(option).then((res) => {
        if (res.error_code === 0) {
          exportLoop(res.data.task_id);
        }
      });
    },
    handleSearch() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    clickSort(e) {
      let sort = "";
      if (e.order == "descending") {
        sort = "desc";
      }
      if (e.order == "ascending") {
        sort = "asc";
      }
      this.searchInfo.sort_type = sort || "desc";
      this.searchInfo.sort_field = e.prop;
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    },
    toOrderDetail(row) {
      // 数据缓存
      PageModule.SET_PAGE_INFO({
        name: "financialOrderLog",
        key: "search_info",
        value: this.searchInfo,
      });
      sessionStorage.setItem(
        "finance-center-order-management-order-log-cache",
        JSON.stringify({
          page: this.page,
          page_size: this.pageSize,
          search_info: this.searchInfo,
        })
      );
      this.$router.push({
        name: "orderManageDetail",
        query: {
          id: row.order_id,
        },
      });
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
  },
  // beforeDestroy() {
  //   sessionStorage.setItem(
  //     "finance-center-order-management-order-log-cache",
  //     JSON.stringify({
  //       page: this.page,
  //       page_size: this.pageSize,
  //       search_info: this.searchInfo,
  //     })
  //   );
  // },
};
</script>
<style lang="scss" scoped>
.log-container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  overflow: hidden;
  .statistics-wrap {
    margin-top: 24px;
    .statistics-total {
      color: #5c5d5e;
      margin-bottom: 12px;
      font-size: 14px;
      line-height: 14px;
      span {
        margin-left: 24px;
      }
    }
  }
}
</style>
